import { render, staticRenderFns } from "./ManageButtons.vue?vue&type=template&id=227b4a9a&scoped=true"
import script from "./ManageButtons.vue?vue&type=script&lang=ts"
export * from "./ManageButtons.vue?vue&type=script&lang=ts"
import style0 from "./ManageButtons.vue?vue&type=style&index=0&id=227b4a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b4a9a",
  null
  
)

export default component.exports